// Recovered compiled webpack factory 11126. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "handleMutable", {
      enumerable: !0,
      get: function () {
        return o;
      },
    }));
  let n = r(86343);
  function a(e) {
    return void 0 !== e;
  }
  function o(e, t) {
    var r, o;
    let i = null == (r = t.shouldScroll) || r,
      s = e.nextUrl;
    if (a(t.patchedTree)) {
      let r = (0, n.computeChangedPath)(e.tree, t.patchedTree);
      r ? (s = r) : s || (s = e.canonicalUrl);
    }
    return {
      canonicalUrl: a(t.canonicalUrl)
        ? t.canonicalUrl === e.canonicalUrl
          ? e.canonicalUrl
          : t.canonicalUrl
        : e.canonicalUrl,
      pushRef: {
        pendingPush: a(t.pendingPush) ? t.pendingPush : e.pushRef.pendingPush,
        mpaNavigation: a(t.mpaNavigation) ? t.mpaNavigation : e.pushRef.mpaNavigation,
        preserveCustomHistoryState: a(t.preserveCustomHistoryState)
          ? t.preserveCustomHistoryState
          : e.pushRef.preserveCustomHistoryState,
      },
      focusAndScrollRef: {
        apply: !!i && (!!a(null == t ? void 0 : t.scrollableSegments) || e.focusAndScrollRef.apply),
        onlyHashChange: t.onlyHashChange || !1,
        hashFragment: i
          ? t.hashFragment && "" !== t.hashFragment
            ? decodeURIComponent(t.hashFragment.slice(1))
            : e.focusAndScrollRef.hashFragment
          : null,
        segmentPaths: i
          ? null != (o = null == t ? void 0 : t.scrollableSegments)
            ? o
            : e.focusAndScrollRef.segmentPaths
          : [],
      },
      cache: t.cache ? t.cache : e.cache,
      prefetchCache: t.prefetchCache ? t.prefetchCache : e.prefetchCache,
      tree: a(t.patchedTree) ? t.patchedTree : e.tree,
      nextUrl: s,
    };
  }
  ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
    void 0 === t.default.__esModule &&
    (Object.defineProperty(t.default, "__esModule", { value: !0 }),
    Object.assign(t.default, t),
    (e.exports = t.default));
}
